import { ref } from "vue";
import { DEFAULT_BRAND, type BrandConfig } from "./brand";

/**
 * Reactive reference to the currently active brand. Components use this
 * instead of hardcoding "Choir" / the default tagline / the Entra login
 * label. Populated at boot by `main.ts` → `loadBrand()`.
 *
 * Lives in its own module so tests can import + reset it without dragging
 * in `main.ts`'s side-effectful `createApp(...)`.
 */
export const brandRef = ref<BrandConfig>(DEFAULT_BRAND);
